import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=98d516d4&scoped=true&lang=pug&"
import script from "./FeatureCard.vue?vue&type=script&lang=js&"
export * from "./FeatureCard.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=98d516d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d516d4",
  null
  
)

export default component.exports